import ambientModeSlice from './slice';

export const { setShouldSkipOnboardingPrompt, setLastSelectedBackgroundMusicURL } = ambientModeSlice.actions;
